export class RiskDashboardFilter {
  OrderdByColoumName: string;
  OrderdBy: string;
  PotentialRiskPears: string[] = [];
  RiskIdentified: string[] = [];
  Status: number[] = [];
  StartRowIndex: number;
  EmployeeId: number;
  TotalRow: number;
  SearchText: string;
  RiskAddedFromDate: Date;
  RiskAddedToDate: Date;
  RiskSources: number[] = [];
  UnitId: number;
  CurrentPage: number;
  SelectAll: boolean;
  Units: number[] = [];
  ToolId: number = 0;
}
